
import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	startAnswering({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/exam/startAnswering?planId=${params.planId}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  submit({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/exam/submit?examId=${params.examId}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/exam/save`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  listMyExam({ commit }, data) {
		return new Promise((resolve, reject) => { 
			axios.post(`/examination/exam/listMyExam`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getExamResult({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/exam/getExamResult?planId=${params.planId}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
  
}
